import {MathUtils} from 'three';

export const FLIGHT_VERTICAL_HOLD=.5;
export const FLIGHT_VERTICAL_FULL=.65;

/** Near-vertical powered travel aligns to its path before the sustained envelope
 * qualifies, so applying thrust cannot flatten an already upright coast. */
export function flightVerticalAlignment(horizontal:number,climb:number):number {
  if(!Number.isFinite(horizontal)||!Number.isFinite(climb)||climb<=0)return 0;
  return MathUtils.smoothstep(Math.atan2(climb,Math.max(.01,Math.abs(horizontal))),Math.PI/3,Math.PI*4/9)
    *MathUtils.smoothstep(climb,6,9);
}

/** Qualification resets immediately; vertical alignment and the wing circle
 * release through this envelope when thrust or the vertical path ends. */
export class FlightVerticalPose {
  amount=0;
  /** Rise velocity of the engaging envelope (1/s). */
  private rate=0;
  reset():void{this.amount=0;this.rate=0;}
  update(dt:number,qualifiedSeconds:number):number{
    const target=MathUtils.smoothstep(qualifiedSeconds,FLIGHT_VERTICAL_HOLD,FLIGHT_VERTICAL_FULL);
    const h=Math.max(0,Number.isFinite(dt)?dt:0);
    if(target>=this.amount){
      // Engage along a critically damped spring (exact for any frame time):
      // the body eases into the upright climb instead of kinking into it.
      const omega=10,offset=this.amount-target,decay=Math.exp(-omega*h),c=this.rate+omega*offset;
      this.amount=target+(offset+c*h)*decay;
      this.rate=(this.rate-omega*c*h)*decay;
      if(this.amount>target){this.amount=target;this.rate=0;}
    }else{
      this.rate=0;
      this.amount+=(target-this.amount)*(1-Math.exp(-5.5*h));
    }
    if(target===0&&this.amount<1e-6)this.amount=0;
    return this.amount;
  }
}
